export function Wordmark({ size }: { size?: number }) {
  return (
    <span className="wordmark" style={size ? { fontSize: size } : undefined}>
      <span className="dot" />
      <span>inbox</span>
    </span>
  );
}
